/* ============================================================================
 * main.js — site-wide bootstrap (entry point referenced by all pages)
 * ----------------------------------------------------------------------------
 * Component modules (header, mini-cart, search-overlay, etc.) auto-mount via IIFE + DOMContentLoaded. This file
 * is intentionally minimal — its primary role is to:
 *   1. Avoid the 404 noise from <script type="module" src="/assets/js/main.js">
 *   2. Provide a single, predictable entry point for future bootstrap logic
 *      (analytics, error reporters, feature flags, etc.)
 * ========================================================================== */
(function () {
  'use strict';

  // Mark booted so component modules know main.js loaded (some may want to wait).
  // The `modules` registry advertises which IIFE component scripts the page expects;
  // each module self-registers on its own DOMContentLoaded but consumers
  // (e.g. dev tooling) may inspect this list to verify integration.
  try {
    window.KoshoApp = window.KoshoApp || {
      booted: true,
      version: '1.0.0',
      modules: [
        'focus-trap',
        'header',
        'mobile-nav',
        'mini-cart',
        'search-overlay',
        'chatbot'
      ]
    };
  } catch (e) {}

  // Optional: dispatch a single "site ready" event others can listen to.
  function ready() {
    try { document.dispatchEvent(new CustomEvent('koshosg:app:ready')); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
